export default "__VITE_ASSET__BiWW3vs3__"